(function ($) {
	'use strict';
	$(function () {
		$(document).on('click', '.filter-panel.is-collapsible .filter-heading', function () {
			$(this).closest('.filter-panel').toggleClass('is-collapsed');
		});
	});
})(jQuery);
